import type { FontAwesomeIcon } from '@ur-solutions/react-components'

import type { IssueActionLog } from '../../types.graphl'

export type ActionType = IssueActionLog['action']

type ActionVisual = { icon: FontAwesomeIcon; color: string; bg: string }

/** Rail dot icon + colors per action type. */
const ACTION_VISUALS: Record<ActionType, ActionVisual> = {
  CREATED: { icon: 'plus', color: 'text-blue-600', bg: 'bg-blue-50' },
  UPDATED: { icon: 'pen', color: 'text-blue-600', bg: 'bg-blue-50' },
  CLOSED: { icon: 'check', color: 'text-green-600', bg: 'bg-green-50' },
  REOPENED: { icon: 'rotate-left', color: 'text-amber-600', bg: 'bg-amber-50' },
  ARCHIVED: {
    icon: 'box-archive',
    color: 'text-tertiary',
    bg: 'bg-quaternary',
  },
  RESTORED: { icon: 'box-open', color: 'text-tertiary', bg: 'bg-quaternary' },
  EXPORTED: { icon: 'download', color: 'text-violet-600', bg: 'bg-violet-50' },
  REMINDER_SENT: { icon: 'bell', color: 'text-amber-600', bg: 'bg-amber-50' },
}

export const getActionVisual = (action: ActionType): ActionVisual =>
  ACTION_VISUALS[action] ?? ACTION_VISUALS.UPDATED
